// Pure model for the home-screen "Notifications" card (10/07/2026, Josh: "the recent activity tab
// should be combined with the notifications box ... include both notifications and recent activities").
// Merges the user's notifications (bell source, /api/notifications) with upload activity
// (dashboard recent_activity: Daily Import batches + legacy sessions) into one time-ordered feed.

const ts = (v) => {
  const t = new Date(v || 0).getTime();
  return Number.isFinite(t) ? t : 0;
};

export const NOTIFICATION_ICONS = {
  deal_status_change: '📊',
  payment_due: '💰',
  application_status: '📝',
  commission_approved: '✅',
  new_deal: '🎉',
  deal_paid_off: '🏁',
  funding_confirmation: '🖊️',
  sms_received: '💬',
  stage_change: '🔁',
  reminder_due: '⏰',
  job: '🤖',
  default: '🔔',
};

export const iconFor = (type) => NOTIFICATION_ICONS[type] || NOTIFICATION_ICONS.default;

const UPLOAD_STATUS_LABEL = {
  approved: 'posted',
  committed: 'posted',
  success: 'posted',
  pending: 'awaiting approval',
  committing: 'posting…',
  commit_failed: 'FAILED',
  rejected: 'rejected',
};

export const uploadStatusLabel = (status) => UPLOAD_STATUS_LABEL[status] || status || '';

export const uploadTone = (status) => {
  if (['approved', 'committed', 'success'].includes(status)) return 'ok';
  if (status === 'commit_failed') return 'bad';
  if (status === 'pending' || status === 'committing') return 'wait';
  return 'muted';
};

export const notificationItem = (n) => ({
  kind: 'notification',
  key: `n:${n.id}`,
  id: n.id,
  at: n.created_at,
  title: n.title || '',
  detail: n.message || '',
  icon: iconFor(n.type),
  unread: !n.read,
  priority: n.priority || 'normal',
  href: n.action_url || null,
  raw: n,
});

export const uploadItem = (u) => {
  const imported = (u.counts || {}).imported ?? 0;
  const who = u.uploaded_by_email ? ` · ${u.uploaded_by_email}` : '';
  const rows = uploadTone(u.status) === 'ok' ? ` · ${imported} row${imported === 1 ? '' : 's'}` : '';
  return {
    kind: 'upload',
    key: `u:${u.id}`,
    id: u.id,
    at: u.uploaded_at,
    title: `${(u.upload_type || 'upload').toUpperCase()} upload — ${uploadStatusLabel(u.status)}`,
    detail: `${u.filename || ''}${who}${rows}`,
    icon: u.upload_type === 'bounces' ? '↩️' : '📥',
    unread: false,
    status: u.status,
    tone: uploadTone(u.status),
    href: '/daily-import-review',
    raw: u,
  };
};

// Newest first; unread notifications are NOT pinned (the feed is chronological — Josh reads it top-down).
export const mergeFeed = (notifications = [], activity = [], limit = 12) => {
  const items = [
    ...(notifications || []).filter(Boolean).map(notificationItem),
    ...(activity || []).filter(Boolean).map(uploadItem),
  ];
  items.sort((a, b) => ts(b.at) - ts(a.at));
  return limit ? items.slice(0, limit) : items;
};

export const feedCounts = (notifications = [], activity = []) => ({
  unread: (notifications || []).filter((n) => n && !n.read).length,
  uploads: (activity || []).length,
  pendingUploads: (activity || []).filter((u) => u && (u.status === 'pending' || u.status === 'committing')).length,
});
